import { createPostAPI, createPatchAPI } from '@cuemath/rest-api';

import { BASE_URL } from '../constants/api';

const { usePost: useEmailPost } = createPostAPI({
  getURL: (_, id) => {
    return `${BASE_URL}/parents/${id}/check-email-availability/`;
  },
});

const { usePatch: useEmailPatch } = createPatchAPI({
  getURL: id => `${BASE_URL}/parents/${id}/update-email/`,
});

export { useEmailPost, useEmailPatch };
